import { useCallback, useMemo } from "react";
import { useCustomGetDailyFormInspectionQuery } from "generated/graphql";

export default function useGetDailyFormInspection({ id }: { id: string }) {
  const {
    loading,
    error,
    data: graphqlData,
  } = useCustomGetDailyFormInspectionQuery({
    variables: { id },
  });

  const getData = useCallback(({ data }: { data: any }) => {
    return data?.getDailyFormInspection || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  return { loading, error, data, getData };
}
